let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k7RZQ")).then(() => parcelRequire('hAVgU'));